export const MenuKeys = {
    paging: "getMenuPaging",
    get: "getMenuById",
    delete: "deleteMenu",
    create: "createMenu",
    update: "updateMenu",
    getRoles: "getMenuRolesMapping",
    addRoles: "addMenuRolesMapping",
    deleteRoles: "deleteMenuRolesMapping",
    notInRoles: "menuNotInRoles",
    getFeatures: "getMenuFeaturesMapping",
    addFeatures: "addMenuFeaturesMapping",
    deleteFeatures: "deleteMenuFeaturesMapping",
    notInFeatures: "menuNotInFeatures",
    tree: "menuTreeView"
}